module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_1750_Active@1x-3451ad9e198cc0d6fb85075e67caf21e.png";